<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @checkboxChange="(e) => (checkedRow = e)"
      @printData="printData"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
      >
        <template slot-scope="{ form }">
          <div class="ml-2" v-if="allow('E')">
            <el-badge v-if="checkedCount > 0" :value="checkedCount">
              <b-button
                :disabled="!checkedCount"
                size="sm"
                variant="outline-primary"
                class="printer-button"
                :class="{ clearable: !!checkedCount }"
                @click="exportFile(form)"
              >
                <i class="el-icon-download" />
                {{ $l('INDEX.btn_print') || '打印' }}
                <i
                  class="el-icon-circle-close"
                  @click.stop="clearCheckboxRow"
                />
              </b-button>
            </el-badge>

            <!-- 没有选中项时，只渲染普通按钮 -->
            <b-button
              v-else
              :disabled="!checkedCount"
              size="sm"
              variant="outline-primary"
              class="printer-button"
              :class="{ clearable: !!checkedCount }"
              @click="exportFile(form)"
            >
              <i class="el-icon-download" />
              {{ $l('INDEX.btn_print') || '打印' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </div>
        </template>
      </PageHeader>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <ChooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        templateGroup: chooseTemplateOptions.templateGroup
      }"
      :exportOptions="{
        params: { searchForm: chooseTemplateOptions.searchForm }
      }"
      @confirmClose="clearCheckboxRow"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import ChooseTemplate from '@/views/factory/transport/shipmentDetailQuery/components/choose-template'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, ChooseTemplate },
  data() {
    return {
      usePage: true,
      checkedRow: [],
      chooseTemplateOptions: {
        visible: false,
        templateGroup: 'mrp-material-inspection-group',
        searchForm: {}
      }
    }
  },
  computed: {
    checkedCount() {
      return !this.checkedRow ? 0 : this.checkedRow.length
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .materialInspectionListApi({
          ...form,
          ...this.page
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'quality-iqcInspectionReport-detail',
        params: { ...params, pageType },
        query
      })
    },
    exportFile(form) {
      const listCode = this.checkedRow.map((e) => e.inspectionCode)
      this.chooseTemplateOptions.visible = true
      this.chooseTemplateOptions.searchForm = {
        ...form,
        listCode
      }
    },
    printData(data) {
      this.chooseTemplateOptions.visible = true
      this.chooseTemplateOptions.searchForm = {
        listCode: [data.inspectionCode]
      }
    },
    clearCheckboxRow() {
      this.checkedRow = []
      this.$refs.main.clearCheckboxRow()
    }
  }
}
</script>
<style lang="scss" scoped>
.printer-button {
  .el-icon-circle-close {
    display: none;
  }
}
.printer-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
